import React from 'react'

type Option<V> = {
  value: V
  disabled?: boolean
}
export function useSelections<V, T extends Option<V>>(opts: T[], defaultSelected?: V[], onSelect?: (selected: V[]) => void) {
  const options = opts.filter((opt) => !opt.disabled)
  const [selected, setSelected] = React.useState(defaultSelected ?? [])
  const select = (item: V) => {
    setSelected([...selected, item])
    onSelect?.(selected)
  }
  const isSelected = (item: V) => selected.includes(item)
  const unSelect = (item: V) => {
    setSelected(selected.filter((i) => i !== item))
    onSelect?.(selected)
  }
  const selectAll = () => {
    setSelected(options.map((opt) => opt.value))
    onSelect?.(selected)
  }
  const unSelectAll = () => {
    setSelected([])
    onSelect?.(selected)
  }
  const allSelected = options.every((opt) => selected.includes(opt.value))
  return {
    selected: selected as V[],
    noneSelected: !selected?.length,
    allSelected,
    partiallySelected:
      options.some((opt) => selected.includes(opt.value)) && !options.every((opt) => selected.includes(opt.value)),
    setSelected,
    isSelected,
    select,
    unSelect,
    toggle: (item: V) => {
      if (isSelected(item)) unSelect(item)
      else select(item)
    },
    selectAll,
    unSelectAll,
    toggleAll: () => {
      if (allSelected) unSelectAll()
      else selectAll()
    },
    selectedOptions: options.filter((opt) => selected.includes(opt.value)),
  }
}
